import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

/**
 * Reusable Dashboard Export Button
 *
 * Usage:
 * const { onExport, isExporting } = useDashboardExcelExport({ ... });
 *
 * <DashboardExportButton
 *   onExport={onExport}
 *   isLoading={isExporting}
 *   tooltip="Export dashboard data"
 *   disabled={someCondition}
 *   disabledReason="Data is still loading"
 * />
 */
export default function DashboardExportButton({
  onExport,
  isLoading = false,
  tooltip = 'Export to Excel',
  disabled = false,
  disabledReason = '',
  size = 'medium',
  color = 'primary',
  sx = {}
}) {
  const finalTooltip = disabled && disabledReason
    ? `${tooltip} — ${disabledReason}`
    : tooltip;

  return (
    <Tooltip title={finalTooltip} placement="top">
      <span>
        <IconButton
          onClick={onExport}
          disabled={disabled || isLoading}
          size={size}
          color={color}
          sx={{
            '&:hover': {
              backgroundColor: 'rgba(10, 79, 180, 0.08)',
            },
            ...sx
          }}
        >
          <DownloadIcon
            sx={{
              color: disabled || isLoading ? '#cccccc' : '#0A4FB4',
              animation: isLoading ? 'pulse 1.5s ease-in-out infinite' : 'none',
              '@keyframes pulse': {
                '0%, 100%': { opacity: 1 },
                '50%': { opacity: 0.6 },
              }
            }}
          />
        </IconButton>
      </span>
    </Tooltip>
  );
}

